import { coreActions } from '@sonar-software/sonar-core';
import { DetailSubsection } from '../DetailSubsection';
import React from 'react';
import { TextEditor } from '../editor';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAction, useSonarObjectReference } from '@hooks';

export interface BusinessContextNotesProps {
	sonarObjectId: number;
}

export const BusinessContextNotes: React.FC<BusinessContextNotesProps> = ({ sonarObjectId }) => {
	const notes = useSonarObjectReference(sonarObjectId)?.context?.notes ?? '';

	const updateSonarObjectContext = useAction(coreActions.requestPatchCoreSonarObjectsContext);

	const handleSave = (content: string) => {
		updateSonarObjectContext({
			context: { notes: content },
			sonarObjectId
		});
	};

	return (
		<DetailSubsection title={ COPY_SPECIFIC.NOTES }>
			<TextEditor
				canBeEmpty
				content={ notes ?? '' }
				onSave={ handleSave }
				placeholder={ PLACEHOLDERS_COPY.ADD_ADDITIONAL_NOTES } />
		</DetailSubsection>
	);
};
